angular.module('mtic').constant('ITEM_VERSION_MAP', {
    "mtic_c3_m1_assessment":"0.4.12",
    "mtic_c3_m1_bike_tachometer": "Hw9AsuXR.tiPUd5Drk39BFQdDep_0Yj7",
    "mtic_c3_m1_elephants": "tO.KinG880iiqRfTrzC3Ahj7esRN_FU.",
    "mtic_c3_m1_fish": "3t0lKF8cFRDCgwnl8cJS8viZEkzd_H2h",
    "mtic_c3_m1_skateshop": "XCvG3R.jhPzbAbq7C.POqMIBtjIADT1P",
    "mtic_c3_m1_sticker": "n3TrpNbUEQRM4PmwpJ7fbE79vTTbJoZl",
    "mtic_c3_m1_airplane_porto": "kjgZuzSN_cf32Vucv7L94bK1C_PVfGMj",
    "mtic_c3_m1_train_paris": "PP9llPLSPNRbEXl2kNgPAJ0e2E5rCFzi",
    "mtic_c3_m1_jump": "S6Yy0eRLxA_HiVD0K1ZZsiI.jfkV9Aa1",
    "mtic_c3_m1_camping": "0GHNnDc1KnCXcqkp2akFInQ9Z2hd2YaS",
    "mtic_c3_m1_lemur": "9XCPVKtC7p_SFok7Xuo0jFyETk4wwyXX",
    "mtic_c3_m1_car_tachometer": "LInsj.PzkYEG4quEUmuIi1fDiww2CbmY",
    "mtic_c3_m1_souvenir_b": "OI7xpq.dj5SDCMR7LDpyr.5WBRsM9G4h",
    "mtic_c3_m1_airport": "IJhikYGIbHCZaifMSq_6dSP1zPJuameP",
    "mtic_c3_m1_souvenir_c": "OH46dUeaYidCbsEaUWieeO369I9e1jNM",
    "mtic_c3_m1_block_tower": "SoU_9v.oR5C1PZMjtSEiix.2tVVsJGsH",
    "mtic_c3_m1_tram": "xqyma0YVaeTfhy_isc.nHkoxZBaMvwQG",
    "mtic_c3_m1_exec_rollercoaster": "gndgdzGSIAeaOYfwjohw1iLd28wbXuJl",
    "mtic_c3_m1_exec_chocolate": "66GoQc4QuR.Ia4Iq0dRxQ63Dt2NDHg_h",
    "mtic_c3_m1_plan_chocolate": "hIQXalX4gAXKAEpT7uyKLlMktS8C4Ih2",
    "mtic_c3_m1_plan_rollercoaster": "j162nfzk8oiU5wtLPlba0z1F5MpiTYWj",
    "mtic_c3_m1_plane": "O9Bw1CfbKHCwSFD.9TviiWKyhABXKCt5",
    "mtic_c3_m1_plan_park": "9ZkWoa7CWuhWDto3IZzAo5CmBX_k6_cd",
    "mtic_c3_m1_plan_bakery": "N4Ie6MC1lOy0HNXeF9kKJrby2eZfb6BF",
    "mtic_c3_m1_flamingo": "ewTbILSTwgcuPvrU.JQE3UG931aTrEnI",
    "mtic_c3_m1_monkey": "aZN5L5JhpiPVfdDTCVDPqb8WryPy7Ldm",
    "mtic_c3_m1_bus": "skKRj2K9Cmy1NQ_IbQ.Wpj57ae4PLJ5F",
    "mtic_c3_m1_exec_bakery": "BDMH19aigzS5FoNtKzclVyZI8hNYOPff",
    "mtic_c3_m1_exec_park": "lPwRcJbFkef8mKFfR.wbNqVn47UlysK5",
    "mtic_c3_m1_logbook": "hV5fjiED0zyHrS4jiOljysFCDA8yQ0AW",
    "mtic_c3_m1_diagnostic":"0.4.8",
    "mtic_c3_m1_summative":"0.3.8",
    "mtic_g78_m1_additivity":"v2.0.36",
    "mtic_g78_m1_analyze_add_line":"v1.0.23",
    "mtic_g78_m1_analyze_coef":"v2.0.29",
    "mtic_g78_m1_analyze_graph":"v1.0.43",
    "mtic_g78_m1_analyze_linear":"v1.0.30",
    "mtic_g78_m1_candy":"v2.1.45",
    "mtic_g78_m1_conv_speed":"v2.0.44",
    "mtic_g78_m1_conv_speed_2":"v2.0.39",
    "mtic_g78_m1_crepes":"v1.1.21",
    "mtic_g78_m1_diag":"v1.0.24",
    "mtic_g78_m1_dist_storm":"v2.0.50",
    "mtic_g78_m1_flooring":"v1.0.61",
    "mtic_g78_m1_graph_form":"v3.1.39",
    "mtic_g78_m1_juice":"v1.0.60",
    "mtic_g78_m1_linearity":"v2.0.48",
    "mtic_g78_m1_look_prop":"v3.0.35",
    "mtic_g78_m1_meeting":"v1.0.53",
    "mtic_g78_m1_open":"v0.2.25",
    "mtic_g78_m1_path":"v1.1.25",
    "mtic_g78_m1_prop_coef":"v2.0.42",
    "mtic_g78_m1_prop_table_a":"v4.1.53",
    "mtic_g78_m1_prop_table_b":"v2.0.20",
    "mtic_g78_m1_recipe":"v3.0.44",
    "mtic_g78_m1_recipe_part_2":"v4.0.33",
    "mtic_g78_m1_robot":"v1.0.56",
    "mtic_g78_m1_rule_three":"v4.0.36",
    "mtic_g78_m1_speed_sound":"v1.0.41",
    "mtic_g78_m1_summ":"v1.0.2",
    "mtic_g78_m1_thunder_lightning":"v2.0.33",
    "mtic_g78_m2_diag_inbook":"v1.0.18",
    "mtic_g78_m2_corre_area":"IE7GOg3nIexlG_LqO0t15YFsNkUSQ19.",
    "mtic_g78_m2_fibonacci":"CCYrIWM7BJtCmJznrcHrVv8QGoMmbHA1",
    "mtic_g78_m2_dist_act":"e0R9U4hAUz7IzyKZjoqNXw9x6NIGk9dl",
    "mtic_g78_m2_dist_act_vpm6":"mBDUV8Gbjh20q4i9CSToB1ICgW_mtMNK",
    "mtic_g78_m2_diag":"jz3NdwChiGkdOxjQFBG_9O_jbiQohL.r",
    "mtic_g78_m2_distrib_add_pt1": "FJ.efav0FBpbs8jzVgIeeegR7rTDFsr1",
    "mtic_g78_m2_distrib_add_pt2": "BIPnc_UL8HUzI8JEx0cHG7qp3zSjsRre",
    "mtic_g78_m2_distrib_add_pt3": "di_oVFlIUZagKhb7zKYyd16RsPiAMesp",
    "mtic_g78_m2_distrib_exer":"gp90s91grWtUBLrDXOezBleI5QOOtiIW",
    "mtic_g78_m2_distrib_exer_vpm6":"j80U37Th7D0UYkUJYDClj7INMVMQLKSE",
    "mtic_g78_m2_distrib_sub_pt1": "66jde1kRPSJwfaYspOIY9AfLCSlQYNfs",
    "mtic_g78_m2_distrib_sub_pt2": "riql_0OQ3wh3XPmNykNobGYXGZnfS4H8",
    "mtic_g78_m2_distrib_sub_pt3": "Oy4rBob_0DqUX4rAFg1.zsiWYxt4i6O6",
    "mtic_g78_m2_distrib_sub_pt4": "Rr2uuObLQ1vEVS7yv8AnD4mQ9NAukjRq",
    "mtic_g78_m2_equiv_expr":"6gWJ0jg5LXZolI.Kr2iSwGxiCRjynRBK",
    "mtic_g78_m2_factoring_ex":"Hgb84pF5DGtGmLTOwhjL1sLBeHQ4EIGe",
    "mtic_g78_m2_factoring_pt1": "7RkU3mG_8nHCX0lElDiCC03dQ1t7MC4E",
    "mtic_g78_m2_factoring_pt2": "zKb8TKhOUVrRI6MY3DP6yLuze47eHGKa",
    "mtic_g78_m2_factoring_pt3": "N_9a_biVWbr9aJc_IxqdoGWGOfE7RB.X",
    "mtic_g78_m2_factoring_pt4": "3D.4XIFYmOFedknJmz6PN8FJpig.dlSO",
    "mtic_g78_m2_grand_stair":"Gm2P4sovmcXWHwrr9F.gkC3TKXYu0DMg",
    "mtic_g78_m2_prog_calc_a": "Xc2jtM2YsPtResKbcBjq42W8HVM8ESZe",
    "mtic_g78_m2_prog_calc_b1": "8f_XxurZFF.y3rYs6PRCCfeH9RR__sM9",
    "mtic_g78_m2_prog_calc_b2": "Tf.IN5oP7XCx4YE3SZcUBMZk5vSF4hz5",
    "mtic_g78_m2_spread_calc_pt1": "b5Jl1tTM_NJJteJ_aojQ7y.sxEuzfsEf",
    "mtic_g78_m2_spread_calc_pt2": "QMzkp4DCpSlJfNMZgVW47Jh3ZQXeQ6.L",
    "mtic_g78_m2_spread_calc_pt3": "7OPvyjKoXZg9t5CpoV3ErtX3xhStCp2D",
    "mtic_g78_m2_prog_calc_b3": "LeyCnhLYuZlq9Z1nqwOK7bLEIRb9XC1z",
    "mtic_g78_m2_grand_stair_pt1":"iV7s6OJIKpi.UFYW59LRnLMlb.ChqGbD",
    "mtic_g78_m2_grand_stair_pt2":"AsbWHGNhSZ7gIbjF6f7P8zD0ZBit83QC",
    "mtic_g78_m2_grand_stair_pt3":"mbzsCbd34pIkBKshjE2jOzs8I6Dv7TMa",
    "run_like_math":"OkMMcRRlUqXUseLbLTKqaBJ4gG4VcdwN",
    "run_like_math_teacher":"3dNf9YzQ2.HIFAXmZ1ZeJ8tXEfZQgJMr",
    "mtic_g78_m3_alg_balance":"v1.0.32",
    "mtic_g78_m3_alice_bob":"v2.2.32",
    "mtic_g78_m3_bracket_incl":"v1.0.45",
    "mtic_g78_m3_bracket_wo":"v1.0.45",
    "mtic_g78_m3_bracket_wo_pt2":"v1.0.37",
    "mtic_g78_m3_class_eq":"v1.0.29",
    "mtic_g78_m3_diag":"v1.1.32",
    "mtic_g78_m3_equal_area":"v1.0.41",
    "mtic_g78_m3_game_sub_pt1":"v1.0.34",
    "mtic_g78_m3_game_sub_pt2":"v1.0.34",
    "mtic_g78_m3_geo_area":"v1.0.40",
    "mtic_g78_m3_geo_perim":"v1.0.33",
    "mtic_g78_m3_graph_area":"v3.3.30",
    "mtic_g78_m3_graph_perim":"v1.1.34",
    "mtic_g78_m3_impos_eq":"v1.0.50",
    "mtic_g78_m3_impos_eq_pt2":"v1.0.41",
    "mtic_g78_m3_inver_oper":"v1.0.33",
    "mtic_g78_m3_inver_oper_pt2":"v1.0.31",
    "mtic_g78_m3_open":"v1.0.32",
    "mtic_g78_m3_receipt":"v2.0.31",
    "mtic_g78_m3_represent_eq":"v1.0.25",
    "mtic_g78_m3_sub_method":"v1.0.27",
    "mtic_g78_m3_summ":"v1.0.12",
    "mtic_g78_m3_word_prob":"v1.0.48",
    "mtic_g78_m3_word_prob_pt2":"v1.0.34",
    "mtic_c3_m34_diag":"v1.0.12",
    "mtic_c3_m34_dot": "WNa_zGYfI7kDe51TDJiA1B3SPVH_DOI6",
    "mtic_c3_m34_dot_vpm4": "3ZZvXir00bL5UPPVJwBDUn0.Cor0gEk4",
    "mtic_c3_m34_helicopter": "uLAtG.S_7wa0L15NS6zpD3AkyyVhV4nv",
    "mtic_c3_m34_dot_invalid": ".serUNsArTdlPSs.7XxWGlMXNbEwKpfl",
    "mtic_c3_m34_dot_invalid_vpm4": "wum__NuKVCg_skF3LH7o8l1p85hzElPr",
    "mtic_c3_m34_addsub_clouds_lv3": "Ir4lzwbJkNpUhwtBlOSSYBmqLtfHrYNh",
    "mtic_c3_m34_addsub_clouds_lv3_vpm4": "jol2EfVQVUhiMso73bkmNA.WBUqjUhEx",
    "mtic_c3_m34_addsub_clouds_lv2": "fgYROSB3WY7fplyOJuUTL60mx0PrfGEr",
    "mtic_c3_m34_addsub_clouds_lv2_vpm4": "pJSzF4lCyDw2iJJ09nUTMWJOYh2y7SJg",
    "mtic_c3_m34_addsub_clouds_lv1": "dmp80qGodU5VpQob3nxs4a39bp1AkBNg",
    "mtic_c3_m34_addsub_clouds_lv1_vpm4": "fqVA0O0ujtB_oxKDFiFBte3botwl9hKM",
    "mtic_c3_m34_decomp_tool": "upgasgQ8nrdgNGfhGWXazr_8NjF04f7L",
    "mtic_c3_m34_comp_digit": "fzu8J82se7KgK3GH1MVS.YWkOTKhlYr2",
    "mtic_c3_m34_comp_digit_vpm4": "k_M6dUTFYzQ.S1vU3zsvSaRXBcoaO2zt",
    "mtic_c3_m34_comp_digit_vpm8": "71dFVC_QFioUp3jwKJ6Ll1sSNEZ2V44U",
    "mtic_c3_m34_zahlen_fill_lv1": "9DdazPB2ZzrHLkdxFHyXXT0n7p7p_j05",
    "mtic_c3_m34_zahlen_fill_lv1_vpm4": "6gD2hSyFc6y6zk.cUYlYf9GdUaUnR_0T",
    "mtic_c3_m34_briefcase": "gnaFp87GCVFGzdXhoRwHTWtB4w_gixla",
    "mtic_c3_m34_get_mult": "9ZUDWAXuPWraAesWNqQsrP9qS_ZPRmvI",
    "mtic_c3_m34_get_mult_vpm4": "IIlTxKBKslxqicnbapFmduce72VHTkqq",
    "mtic_c3_m34_get_mult_vpm8": "ZTgpmZgbkBl_ylmOtIi9yFgyzHh9xMhH",
    "mtic_c3_m34_get_div": "cAF6N5wxufLPhtiUOSVV3Ki2gLRtgFCG",
    "mtic_c3_m34_get_div_vpm4": "OJ4.K.jdcLyi_zEWXaIArGcfetO0Ewyo",
    "mtic_c3_m34_get_div_vpm8": "EgHflArigROl7UbjcXfNEt.WyNq2Zo4T",
    "mtic_c3_m34_place_tool": "cMDKVnihko20vutD.okbqFrHqMB2j_e1",
    "mtic_c3_m34_zahlen_empty_lv1": "L70rA2Ekx.50LMt5hRYVj35eQFr026m8",
    "mtic_c3_m34_zahlen_empty_lv1_vpm4": "WTG8k81Nr_R1d2EFhnKzEokb33_H1Dzz",
    "mtic_c3_m34_zahlen_empty_lv5": "qPqIlrWQiq_KELQFdRrSGdDP5RCnPjDG",
    "mtic_c3_m34_zahlen_empty_lv5_vpm4": "MqpNMT8GJf4Vw2m0C4_82mb8Ds0mcgaj",
    "mtic_c3_m34_zahlen_empty_lv7": "mxm7_5UuLhtAJQpH95YWt21i9LDcOgXm",
    "mtic_c3_m34_zahlen_empty_lv7_vpm4": "UwLFU_Eetw6eVJpzvT2I48ig4EyENcXM",
    "mtic_c3_m34_zahlen_empty_lv6": "lTVLhPKdFvDxBa76PaoQNqGP4V.1lDHy",
    "mtic_c3_m34_zahlen_empty_lv6_vpm4": "ZfjgACkCayxE3tQguRZOLXrWyRJWe_mT",
    "mtic_c3_m34_zahlen_empty_lv8": "W26UxML6XcCxjZZuP98qkw_9BGzNhnQe",
    "mtic_c3_m34_zahlen_empty_lv8_vpm4": "DZUwpGEVF.QZx0dQ8cJh_I2ybt8lFj36",
    "mtic_c3_m34_zahlen_empty_lv3": "I9NFfZuJYQn_lWSmEJJgK.3Df81Yee6W",
    "mtic_c3_m34_zahlen_empty_lv3_vpm4": "lbHH2KxhMGQdMX2qeAZx05qn8In3wbHS",
    "mtic_c3_m34_zahlen_empty_lv4": "naRzDCgEN3VL8uYwq0E.e7bMbOtSUQE6",
    "mtic_c3_m34_zahlen_empty_lv4_vpm4": "7MVSVUrb2czfWjKNAweOkcvC0YlhB1sL",
    "mtic_c3_m34_zahlen_empty_lv9": "EiPL77Hcack2yM0_niZ_FgeS4PasZmxO",
    "mtic_c3_m34_zahlen_empty_lv9_vpm4": "5pWscfgOAZQLZF_FfzXJbA57yUzZ4csw",
    "mtic_c3_m34_zahlen_empty_lv2": "2yvlGs1GPrLtGIOViv4RNwQiKF4ObXpl",
    "mtic_c3_m34_zahlen_empty_lv2_vpm4": "99OlNsoK.imwVwXm0Iwgm03ja710oJhj",
    "mtic_c3_m34_num_zoom": "HEdGTa43D.RkgQgfv_Y7eaqHQGYCEaRb",
    "mtic_c3_m34_fishing_lv1": "VENzt1sB3xdJBiqw3tyaqX3sCYBXTx7U",
    "mtic_c3_m34_fishing_lv1_vpm4": "9Gm1RFT87kQ11vSt27N0EcH_1lpiyXi2",
    "mtic_c3_m34_div_concept_ex": "816vgyvaeW4T_9JV4egzzA5.bFgoczj9",
    "mtic_c3_m34_div_concept_ex_vpm4": "6Mp38JRtGMiGxIznZJJjkaiVq4cP0sl0",
    "mtic_c3_m34_fishing_lv3": "8W09YUHMLvrri5TbCq09_a_Rpf1XPOLM",
    "mtic_c3_m34_fishing_lv3_vpm4": "LfqNeHM68.W8U0ilQjIy_tobPUwmfwhx",
    "mtic_c3_m34_fishing_lv2": "1z0wwoxkU1wysq7X.cexuzyapSl8uVCa",
    "mtic_c3_m34_fishing_lv2_vpm4": "KqDR07BaHHIrZqiafnI3FPuUk_9_v9o.",
    "mtic_c3_m34_fishing_lv4": "47uUxjVAkv8BzWVGay7lkaGT223lgqQ3",
    "mtic_c3_m34_fishing_lv4_vpm4": "h8e4njF1TAmh.wyHgF9kojzOf3j6Z0DV",
    "mtic_c3_m34_toydeli_1k": "m3i4Zji8W2ZojQzylQ3FDsuzHtn54jLD",
    "mtic_c3_m34_toydeli_1m": "FLOgI1m0b14H8dOlESSLPRgCfuNYZlcg",
    "mtic_c3_m34_div_tool": "7Fny3Z3PoSJZGFeLrSZ7q95VVoSCsAxs",
    "mtic_c3_m34_div_tool_vpm4": "RnIA5Fw628SuP5x7PECF8sj0eYzVsMHY",
    "mtic_c3_m34_equal_ex": "tqRTJaS2ROUlk6CWzg9SA.wUip7j6FNZ",
    "mtic_c3_m34_mult_tool": "oLj8GUcPtqRzFxMxTWjoWnWXe43QDbp5",
    "mtic_c3_m34_mult_tool_vpm4": "FBWF7KOKtzUkrFEurg7IkwJd2r_Z.q2H",
    "mtic_c3_m34_multdiv_clouds_lv3": "B4bqVPkLVoUAFIdXxpkyWBNrelYxr6SA",
    "mtic_c3_m34_multdiv_clouds_lv3_vpm4": "YFAcwnXzRUdPvGU.P2rnNLaExiSQ3TrP",
    "mtic_c3_m34_multdiv_clouds_lv1": "X63Q0nNHk9nAMjvO9iKW9cXH6CQybZcE",
    "mtic_c3_m34_multdiv_clouds_lv1_vpm4": "DjYimNHAd5BPfCrXnPNhA5CbGR4pQwdV",
    "mtic_c3_m34_multdiv_clouds_lv2": "Q5ddyyjGxUNST1j9sq5jr3WYSQw.KkmF",
    "mtic_c3_m34_multdiv_clouds_lv2_vpm4": "85trbR82VHcSPl0uttADp4lL6JqFhhgH",
    "mtic_c3_m34_zahlen_fill_lv6": "IWcptUzeae1dO1lqBhT.CoSCajBW6D7i",
    "mtic_c3_m34_zahlen_fill_lv6_vpm4": "d9VbJur6_5.ejMCgSCG33P3sOr8VLczt",
    "mtic_c3_m34_zahlen_fill_lv2": "qoj1fcceJ78Hd0uYIKMfjBqxPUTvo7A4",
    "mtic_c3_m34_zahlen_fill_lv2_vpm4": "pvZAVCuY50foa1jE0ah2QD4ZKNF2_yqo",
    "mtic_c3_m34_zahlen_fill_lv4": "uVtn9r0.zE9_iDX3v3pYlnsnkj6oK4WT",
    "mtic_c3_m34_zahlen_fill_lv4_vpm4": "yYha1PzC.j7S92aO5Djhao2kgwPExehM",
    "mtic_c3_m34_zahlen_fill_lv3": "KcCX01ZdG63dvy8Q36iEk19oeqFJpFFL",
    "mtic_c3_m34_zahlen_fill_lv3_vpm4": "NhJGM2.PQSulC_RR0Dj6gzTlKfLs2HID",
    "mtic_c3_m34_zahlen_fill_lv5": "nfwBEXDG51yuliGQluAnkFhxwjsd2qsk",
    "mtic_c3_m34_zahlen_fill_lv5_vpm4": "QNKs17u5htFVUtOoV65HVCxrctCsKPLU",
    "mtic_c3_m34_mixed_clouds_lv2": "EinqxcVDn4QU3ealF1YtEQRl.KlvviVN",
    "mtic_c3_m34_mixed_clouds_lv1": "H_wohOAjA.koO2e11X72T2NH8WCKdkTw",
    "mtic_c3_m34_decomp_sub": "UUVMIUfPU2aRaJ9c8WN8UxFIP.Jez_wT",
    "mtic_c3_m34_decomp_add": "FZUUUPHi46k1ow1.gENeTjlWNqJYlPFQ",
    "mtic_c3_m34_canoe_lv1": "C_VQB9F5uWPjYpQNM1WMyxj9VbAX1.gC",
    "mtic_c3_m34_canoe_lv1_vpm4": "C7qEHRCWCfZusBLVXA6uSbWoIolbOY0l",
    "mtic_c3_m34_garden_mult_lv3": "7LZeyWmNxcKr9xRUUPVr0Ip9oXxOA7fK",
    "mtic_c3_m34_garden_mult_lv3_vpm4": "j5oViTN3ZKgSc0S8BCSa59FwXw5tx3If",
    "mtic_c3_m34_garden_mult_lv3_vpm8": "PKY8zehnBHaodxQRoyTMKO0htz4UYhEy",
    "mtic_c3_m34_garden_mult_lv2": "dWvuTL5ctu867njs296Hfm4m2Hrpc5fQ",
    "mtic_c3_m34_garden_mult_lv2_vpm4": "tLwVmrXGGEO5ka6gBWcCLDxWSoJYyQOr",
    "mtic_c3_m34_garden_mult_lv2_vpm8": "Kr_2_.fkUIruvqNS2xO3IsrMicumOuKd",
    "mtic_c3_m34_garden_mult_lv1": "TvbCW2MPd2sqX6DxDK6r3eopnUOritaQ",
    "mtic_c3_m34_garden_mult_lv1_vpm4": "C9nVGU9EAlbWBE57ZEp3SkzFHwrw.Oz9",
    "mtic_c3_m34_garden_mult_lv1_vpm8": "IOJhIqdCjqFhETBYT_8jUkoj9HWGxvbP",
    "mtic_c3_m34_toyfac_1m": "Ar9gSG9CKuBGdYOBdW9wW1LjFseJT54E",
    "mtic_c3_m34_place_val": "jWRRSkWm9BnivNUJMm3dmcNXacsD4zOS",
    "mtic_c3_m34_toyfac_1k": "f81bDvRsxwnqRUwud.JjtsEctYAyGb9Y",
    "mtic_c3_m34_equal_lesn": "Ktw7bSEcV9WNX_upC3H_DPhGFR8QZlfK",
    "mtic_c3_m34_div_concept": "wBdoxQrORyMxvlkaobKiOUArG0mGavdI",
    "mtic_c3_m34_div_concept_vpm4": "t7yAry0wzb78OZEPjz4tjF1FZATiIHB3",
    "mtic_c3_m34_canoe_lv2": "qtBedf02z3KRzPI4nUB8_T_a34w57fG_",
    "mtic_c3_m34_canoe_lv2_vpm4": "_Z_Jv5Heo.M1CnYJVTrTvvimEGy25nhZ",
    "mtic_c3_m34_zahlen_fill_intro": ".tzbvFSoLpEt2dPX5_8PkLSfN8EvBrIH",
    "mtic_c3_m34_zahlen_fill_intro_vpm4": "9OTsLY7DlhOd6.B.7u4qa9kV5tA3Br9E",
    "mtic_c3_m34_zahlen_empty_intro": "iQCczZ4GoUkJ4oMzpebbQDpdzjXi2Lsp",
    "mtic_c3_m34_zahlen_empty_intro_vpm4": "uJ3HPyQrip2Hhp2BuzvD6TC5m3zhwBGF",
    "mtic_g78_m4_triominos_pt1": "N8xEiGQqqC9j1skSPIWdgwi6yKU3Rmf5",
    "mtic_g78_m4_triominos_pt2": "ASsKuTq24FQWXhY3U14wIJd.fs4zpzjt",
    "mtic_g78_m4_dominos": "mMROSqg6aHwryWIW732EwUl9WIajBj2Z",
    "area_construction": "0XEDmiD_FkVLNbs9Tr6Ffr9znEI1CKw0",
    "perimeter_construction": "m114IpaZNr8Ez63SG9J4W.FLYWVNd2Bh",
    "perimeter_area_lake": "ZYzclpSgkj_bVm5BUyL.TRWmpyWaKhhJ",
    "mtic_c4_fraction_puzzle_pt2": "wg2_ILzGuN_.hEWhI0dv9qzfgUetk2Rv",
    "mtic_c4_fraction_puzzle_pt4": "WHVMpWrBJ9DfAhzawy1zrXW4yO2MUwM0",
    "mtic_c4_fraction_puzzle_pt3": "N7eyTVmd8P7vZAmYpetIoty6hdo92mOx",
    "mtic_c4_fraction_puzzle_pt1": "M86eNh4KH4dOfTVVOQZYvkr1HQFFl1wA",
    "mtic_c4_fractions_dominos": "qVZExxmfmLnngM64Jladrc6D3odPis4Q",
    "mtic_c4_fractions_triominos_pt2": "8Lleny6SmM6enEh3KGiEV1iwye.4dtO6",
    "mtic_c4_fractions_triominos_pt1": "TCwp8mWtUG313HlgpSoUxFGieHSc.3n1",
    "mtic_c4_fractions_addition_twos": "v4qx3r99AwOSVw6kQ.N38MeEdG00HxXy",
    "mtic_c4_fractions_addition_threes": "awJYA4QZ.H0pJOn9FqKBnAyDMiiL.Qh0",
    "mtic_c4_fractions_determine_ensemble": "_a5X6.kMwKHCNHV99avUQIHDjvQ_uRaJ",
    "mtic_c4_fractions_determine_figure": "r.UTcEIIGE9KJNOl2oorYp7CQk647dud",
    "mtic_c4_fractions_reproduire_partie_1": "daguayRyQWqLIHZilUI5p0BJmQHM4tl6",
    "mtic_c4_fractions_verify_figure": "cwFZn_SVneokV10idEIBP4ImUGZMkO_L",
    "mtic_c4_fractions_reproduire_partie_2": "8wn5ayHqSrtXIafglHuRwqcICCQh7McY",
    "mtic_c4_fractions_drapeaux_partie_1": "QuY6iaK3SVRJAoFCYvjaSEZ8UExg8lFA",
    "mtic_c4_fractions_determiner_droite": "0yHp6L_M33mwM6VMpa.EHeTcuNnUGh0A",
    "mtic_c4_fractions_placer_sur_droite": "iKM5.5Clup5fS23m_k7kGhfHqWrVhqmS",
    "mtic_c4_fractions_comparaison": "c6hVzMF6DzU_sLX1V7DefaEy2k1EoPcB",
    "mtic_c4_fractions_equivalentes": "EVx0kcqbt8.D0EqBNhC64SmxntmrWExi",
    "mtic_c4_fractions_ordonner": "pZ9HxX3GinyhG4muHzAB2SQRa.BWuucX",
    "mtic_c4_fractions_subtraction_twos": "K_73zHF.31uFiu4ceYazsHHx8zniSA0B",
    "mtic_c4_fractions_intercaler": "akg6bUEs_eWQiqEvaLrGpL9SJono6Chj",
    "mtic_c4_fractions_subtraction_threes": "9Uc06xVuR8NeDLqYvgqT8xgsUluPnfUj",
    "mtic_c4_fractions_multiplication_partie_1": "wUbtzgyzcsOcm9ZsYvWuiRayg2tTZ0.8",
    "mtic_c4_fractions_multiplication_partie_2": "ZvhhyD_zq1ipVGh4Zh7Ymqm8c_10Pwts",
    "mtic_c4_fractions_dominos_pt2": "ozzJQLRhVc0sOg7co7Iikoj.cA5M4hna",
    "mtic_c4_fractions_pad": "hpw6pqzOVwS9RM3jPEvbOTVSpRMeqTBv",
    "mtic_c4_fractions_engrenages_partie_2": "LCkNdVXiQaQwW10ds0.LF76hqqVUhVZj",
    "mtic_c4_fractions_engrenages_partie_1": "u.Qo1B9Em6X1.fyYjytiq1U1VGwN9w2q",
    "mtic_c4_decimals_calc_casse": "V8nthOc6Verhh21U4vIk1fwU535Lt5PD",
    "mtic_c4_decimals_expl_conv_dec_part2": "hIrII3qXpc99WIekAodHikVOUDV9r_dq",
    "mtic_c4_decimals_expl_conv_dec_part4": "Y_UWm9XS_.VhT9loeXo1AM0lVNQbdSij",
    "mtic_c4_decimals_expl_frac_Ex": "uB2VSFm4bz2azXOHjzfXBIzb5FdPVRFd",
    "mtic_c4_decimals_droite_zoomee": "g2wWljd9PecPHDs5.X2xjCwcZtWrn2LN",
    "mtic_c4_decimals_compare_num": "r9COeY1SoEPka4_gIQrtcGrZM_cx0Rz9",
    "mtic_c4_decimals_interposing_num": "_LKWdL9YnB5uNl341PYLtG8LR7nsTLXK",
    "mtic_c4_decimals_order_num": "94SS4_bKT9pnN_qNMaqvFz8ffbbz7wDR",
    "mtic_c4_decimals_add_num": "WuuXiV7JchO4iFtrGQi9GUMerOTu.rDU",
    "mtic_c4_decimals_mult_num": "n60RxjtKNEiE9jLAs7kwwbJjfh2aChFR",
    "mtic_c4_decimals_sub_num": "mIeue2C3tlfwUbrkulwl0LhebyUZUQaO",
    "mtic_c4_decimals_est_num_line": "TgN89D6blPqjGpNdiJCPr8MTG67H9bOc",
    "mtic_c4_decimals_div_num": "u884FPRxeK2m1NIBnG0wxuhwUmuGEqIG",
    "mtic_c4_decimals_boite_noire_pt2": "TCcMegIA1_sz_hezpoMAiNKL0WJqfXF7",
    "mtic_c4_decimals_boite_noire_pt1": "MIYY75_Ggf0go8maT8tiZ1l2gDA9RaPa",
    "mtic_c4_decimals_boite_noire_pt3": "WNQ.4XVCqNL2QM06wR97Dn25aLrUi27P",
    "mtic_c4_decimals_dominos_p2": "wz.u5zEWRQJQMLcuYYI0AMjlKG9_pqqW",
    "mtic_c4_decimals_dominos_p3": "VfaQsBUV1HQoeb1seKPxoemrzSBDvzHa",
    "mtic_c4_decimals_convert_time": "ESIfe49iyv7jumBYFUGAZO6aeB2V3w4I",
    "mtic_c4_decimals_dominos_p1": "JcDG_08zZkKnR3_NLWFljgdSmaYBYJOA",
    "mtic_c4_decimals_dj": "QGA9X9HWgaqyD6p30FpVLrUyQ7J_7Je8",
    "mtic_c4_decimals_expl_add_sub_part2": "kDqaC2wS8sxqPq8NaHfXy6CU5CaN1M9M",
    "mtic_c4_decimals_etiquettes_pt2": "i0099QEEW1Uf2vCckmKzP27w84sY1JLB",
    "mtic_c4_decimals_etiquettes_pt1": "GQb3JN.XYW15xFzaLUg4igjWF44GVcvt",
    "mtic_c4_decimals_round_unit": "W5s9wcrQcjNPzyVN6nA9sJgynX25mk9e",
    "mtic_c4_decimals_machine_cafe_pt2": "0XWJvLzWK7M80.a05GjBkumvXbJ2soVD",
    "mtic_c4_decimals_round_time": "sMdoAs4dyNZFFyMrCg_2pSnM0OGBHGW7",
    "mtic_c4_decimals_pendule": "rGm1Bvp_RswLS1A8NBQ0O1nabNF8pTGw",
    "mtic_c4_decimals_meltdown":"wn3WByKdWHbNFs5X3SrN49B7V1vET.xZ",
    "mtic_c4_m5_menuisier": "5TyGwaQ75wcwT2nPa0t0Fpp.kpdvz.t7",
    "mtic_c4_m5_alice_bob_calcul": "Chsb2nsbeGD6CW7rxg3UuU.sXGkdttfy",
    "mtic_c4_m5_arbre": "LOzmNAj0Mqg.7LOa19v7uq.XS7qlDGmx",
    "mtic_c4_m5_athetisme_pt2": ".d6gJrvGaDuG866GC_l190GiASOL3ten",
    "mtic_c4_m5_pattern": "5ue75UmINCJVklkkuVYHuLKspV1zhvYJ",
    "mtic_c4_m5_trouve_bon_point": "5El9ZtU3cj4TR_l40g7qwvZFLkmkrZgs",
    "mtic_c4_m5_trouve_coordonnees": "bZIU.d2P68o9GJumH4NYk889Hhj71MVU",
    "mtic_c4_m5_complete_figure": "eLrgnx7zObvpKSgjGhc.xgJz1PcbZcX.",
    "mtic_c4_m5_repere_couleur": "QXjNJtPa8qivZWP6G4f9FGOLU7TLHX0T",
    "mtic_c4_m5_repere_polygone": "PdIWP0m1qY.lmmBAzaN9niSz9Dy3yMbE",
    "mtic_c4_m5_planche_galton": "QQLnyUlxegxl4Vcq3Y21i00kiylx7vO3",
    "mtic_c4_m5_sport_collectif": "kQWaBslp3CsI89PDIbB00gRBVz9Qe85j",
    "mtic_c4_m5_avezvous_jetons": "USTb1Gz9.b4lIi._s8jcJ7LdHOEVDjd8",
    "mtic_c4_m5_the_captains_rule": "VswgAFxE1aC2PVmVE4MUZPepaX_rlMcF",
    "mtic_c4_m6_orient_nyc": "sr8f9czQ8LWz.Mixb5RgjIrBQHr.5XMt",
    "mtic_c4_m5_syracuse_pt1": "pRNonyVGE9D_cxcMd106f_M4F9eBIxkn",
    "mtic_c4_m5_syracuse_intro": "o2wN4MfOoz.QHHaqBoyClaVhyx8v3V2x",
    "mtic_c4_m5_syracuse_pt2": "NqGRgEIhxC8lSWu4UJIpPlVMi0ebnbWP",
    "mtic_c4_m5_syracuse_pt3": "RjWpqTZrhAIahQKwAD7G49pN3MDfTWpl",
    "mtic_c4_m6_tomb_architechts_pt2": "BpD74ZpYwGWrk1GZ7PrTj1A9YtHsxrMH",
    "mtic_c4_m6_tomb_architechts_pt1": "hlnZ1ZndLsL.hyyf9xsn6iaOuRRvTZzX",
    "mtic_c4_m6_tomb_model_pt1": "wv1WEcHMoSTCJv74EaIDgTuKTt8JZKIZ",
    "mtic_c4_m6_tomb_model_pt2": "_6U5H0kM5BwLHEzI_ZQ85j2bVGwlt7hq",
    "mtic_c4_m6_tomb_build_ex": "H734ERum8fnAGC1FFueaSluEqpjSlfXw",
    "mtic_c4_m6_conv_len_b": "VgEe5SnoUK9elWfQLvlOUD_nyMNQ6GAJ",
    "mtic_c4_m6_conv_len_pt5": "1vgOQxSgsG7AlAO4QV_yPqbQdYxIa6WD",
    "mtic_c4_m6_conv_len_ex": "drwYCeADXMrkHrVaEfi_NBtT4SM8A0LY",
    "mtic_c4_m6_conv_len_pt3": "g.gqCjpi_wTglwUxbIDGuzw07DXWb776",
    "mtic_c4_m6_conv_area_ex": "jNtKhKjbxXe0dmuZk9dYU0kQ38Hi_RDD",
    "mtic_c4_m6_conv_vol_ex": "IFwqb3cnkiHkD0Mae_zwUJShlAyL3SoD",
    "mtic_c4_m6_decor_axial_ex": "4eRRP_iRUtCS8gty5iYTE4piAUWxln3o",
    "mtic_c4_m6_decor_radial_ex": "_fIPCwdsLMS56KJH4M4Fd65_SHGxZ9y7",
    "mtic_c4_m6_decor_transl_ex": "CEAZmN5fDuVjbVe7YU6XBQ5zK1RAWvb_",
    "mtic_c4_m6_cube": "FRNxvujadHcLOQ.7mF7vD59Mr3IVnwhB",
    "mtic_c4_m6_cube_squared": "rQFiPMqu6Hkv7o1mRHlV54IMsdvqYtfa",
    "mtic_c4_m6_pat_et_com": "euj6xP9Qwd5LFgPDKvRXLN_uqGepKHd7",
    "mtic_c4_m6_cube_squared_pt2": "2ZWsx..4jk3gtr80QLDTj.cQdJL3Q5Ej",
    "mtic_c4_m6_symm_find": "8QSQ3s1YumNQiQdWym4RULBYjhXmrge7",
    "mtic_c4_m6_transl_find": "tlfrxAzimUpm6LYyVsZVzNeJUMGvh39U",
    "mtic_c4_m6_construct_angle": "YkVhRvc_7oBJEcF2k4A9l4_c6Lr.qyN_",
    "mtic_c4_m6_suite_figure": "zwhtAT59dj9XdjShjW4Nc2LLsnaY.gHA",
    "mtic_c4_m6_conv_area_b": "oAIGHEp43_e_yNIn1lfPZZqjL3U3IP4C",
    "mtic_c4_m6_conv_vol_b": "LZ9AlsaZ2HmxuIVQRaf_9Mp24cZk_3Ls",
    "mtic_c4_m6_symm_place": "08.Tzq33ac2XbapvwmzlFAdvNI9tR3eP",
    "mtic_c4_m6_paint_cube_pt1": "X8rp9zbmFouOeivALHXNFUbTXQqD_Wjt",
    "mtic_c4_m6_paint_cube_pt2": "Qi4UnMkakb4jTaFwT0DTBcMBr2aaIFRX",
    "mtic_c4_m6_transl_place": "u.UdrzTQqYiawsZSCG8tFYpuhGpsfTqF",
    "mtic_c4_m6_conv_all": "yHMZGwP35VEy38sZ3vyX6hk0tkmtXt1k",
    "mtic_c4_m5_construct_diagram": "sQoNv86pYNplAd3pPUIRV0zG.lhUGgUM",
    "addition_soustraction_decompose": "J_YdwHVT4jUm5aBGJtBW4BFiJ1jZdqQJ",
    "soustraction_decompose_1": "SxyhDCwGzkTmFIiYHhVn6xKI.A27JGEP",
    "multiplication_addition_distributivite": "CZ6xySsg5UR3fdoaY1qLBorIgiu0HeKl",
    "factors_creating_result": "JIo7mRF9cR0r6QCcmCfyXqbNqbz4_.FW",
    "factors_create_product": "8pv.WBGNzHVHSYhVEpUnt.8G6RWIdkDn",
    "multiplication_decompose": "BSXDmZvkMbPOkVMy8U5FyCm8hS68IZXS",
    "mtic_c4_m2_calculator": "g26xALFRtslA9YjoLOnvUCFZk4KXZtHv",
    "lagent_codebar_3_0": "jdtodwKqcwTzzZFlJR7AzP24SE8fqw2x",
    "lagent_codebar_3_1_v2": "Aq.FgR8hX55TNtSfFq2VhguzWIaeZrMk",
    "lagent_codebar_3_2_v2": "OHtdA_At8vXjSd3hDwX40YmWbX1a2ZGE",
    "lagent_codebar_3_3_v2": "ADy3ymkDwG7v7QdbDPAIawPMz9sAJ.uz",
    "lagent_codebar_4_2_v2": "5C2vovD.69agHKyurLIm_hsObC5aVzU6",
    "lagent_codebar_4_3_v2": "ubJpHqEdS49fldoJtm7ghBboF6bwjojW",
    "lagent_codebar_4_4_v2": "ku.r2qt9rnF2Ow6ANGAgREJ8COyggTpp",
    "multiplication_division_calcul_relier_mult": "8IakBQ3sUO9uXIvs4pqnPiq684BPh4P7",
    "multiplication_division_calcul_relier_div": "b3fFgiCKh9vrUX_aw7tccpIjPEiz8X7l"
});